import BaseLayout from "../components/layout/layout-with-sider/BaseLayout";
import {Card, Tabs} from "antd";
import {useEffect, useState} from "react";
import ApiService from "../services/ApiService";
import {DataGridProvider} from "../components/data-grid/DataGridContext";
import CheckHistory from "../app-components/CheckHistory";
import CompareHistory from "../app-components/CompareHistory";
import UserDashboardData from "../components/UserDashboardData";
import ProjectTable from "../app-components/ProjectTable";

export default function UserDashboard() {
    const [statistics, setStatistics] = useState({})

    const getStatistics = async () => {
        const res = await ApiService.UserProject.UserStatistics()
        if(res.success) {
            setStatistics(res.data)
        }
    }

    useEffect(() => {
        getStatistics()
    }, [])

    return (
        <>
            <BaseLayout>
                <UserDashboardData
                    projectCount={statistics.projectCount}
                    planCount={statistics.planCount}
                    checkCount={statistics.checkCount}
                    compareCount={statistics.compareCount}
                    checkMessageCount={statistics.checkMessageCount}
                    compareMessageCount={statistics.compareMessageCount}
                />
                <br/>
                <Card>
                    <Tabs>
                        <Tabs.TabPane tab={'Check History'} key={'Check History'}>
                            <DataGridProvider>
                                <CheckHistory />
                            </DataGridProvider>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={'Comparison History'} key={'Comparison History'}>
                            <DataGridProvider>
                                <CompareHistory />
                            </DataGridProvider>
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={'Saved Projects'} key={'Projects'}>
                            <DataGridProvider>
                                <ProjectTable />
                            </DataGridProvider>
                        </Tabs.TabPane>
                    </Tabs>
                </Card>
            </BaseLayout>
        </>
    )
}